import { UserKindEnum } from '../../types/enums';

export const canUsePdfImport = (user: { kind?: UserKindEnum; employer?: unknown }): boolean =>
  user.kind === UserKindEnum.Agency ||
  ((user.kind === UserKindEnum.Broker || user.kind === UserKindEnum.Manager) &&
    user.employer != null);
